const fileTypePaths = {
  '7z': 'file-type-7z.png',
  avi: 'file-type-avi.png',
  bmp: 'file-type-bmp.png',
  csv: 'file-type-csv.png',
  doc: 'file-type-doc.png',
  docx: 'file-type-docx.png',
  gz: 'file-type-gz.png',
  jpeg: 'file-type-jpg.png',
  jpg: 'file-type-jpg.png',
  mov: 'file-type-mov.png',
  mpeg: 'file-type-mpeg.png',
  pdf: 'file-type-pdf.png',
  png: 'file-type-png.png',
  ppt: 'file-type-ppt.png',
  rar: 'file-type-rar.png',
  svg: 'file-type-svg.png',
  tar: 'file-type-tar.png',
  txt: 'file-type-txt.png',
  wav: 'file-type-wav.png',
  zip: 'file-type-zip.png',
};

// TODO Better default
// eslint-disable-next-line
export function getFileTypeImage(extension = '') {
  return fileTypePaths[extension.toLowerCase()] || 'file-type-doc.png';
}

const thumbnailTypes = {
  'image/png': true,
  'image/gif': true,
  'image/jpeg': true,
  'application/pdf': true,
};

export function isFileImage(file) {
  if (!file || !file.mimeType || !file.mimeType.split) {
    return false;
  }
  return file.mimeType.split('/')[0] === 'image';
}

export function hasThumbnail(mimeType) {
  return !!thumbnailTypes[mimeType];
}
